// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saved-payment-modal-root {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.saved-payment-modal-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
}

.saved-payment-modal-title {
  display: flex;
  gap: 8px;
  align-items: center;
}

.saved-payment-modal-root .container-tabs {
  width: 100%;
  display: flex;
  padding: 4px 20px 4px 20px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px;
  background: var(--Global-Neutral-Grey-200, #f8f8f8);
}

.active-tab {
  display: flex;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  background: var(--Global-Base-White, #fff);
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
  cursor: pointer;
}

.inActive-tab {
  display: flex;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  cursor: pointer;
}

.active-tab-font.MuiTypography-root {
  color: var(--Global-Neutral-Grey-1300, #0a090b);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.02px;
}

.inActive-tab-font.MuiTypography-root {
  color: #4f4d55 !important;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.saved-payment-modal-content {
  width: 100%;
  height: 483px;
}

.saved-payment-warning-container {
  display: flex;
  padding: 6px 16px;
  align-items: flex-start;
  gap: 8px;
  border-radius: 4px;
  background: var(--Sunrise-Yellow-1, #feffe6);
  box-shadow: 0px 0px 0px 1px #fff;
  margin: 0px 32px 16px 32px;
}

.unselectall-warning-msg {
  color: var(--character-primary-85, rgba(0, 0, 0, 0.85));
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 166.667% */
  letter-spacing: 0.16px;
}

.scroll-container {
  height: 300px;
  overflow-y: scroll;
}

.category-items-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 16px;
  padding: 0px 32px 76px 32px;
}

.category-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--borderRadius, 4px);
  border-radius: 6px;
  border: 1px solid var(--Global-Neutral-Grey-600, #dcdcde);
}

.psp-img-title {
  display: flex;
  padding: 12px;
  align-items: center;
  width: 200px;
  gap: 4px;
}

.scrollable-div::-webkit-scrollbar {
  position: absolute;
  left: 10px;
}

.category-font {
  color: #0d1021;
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.processor-container {
  display: flex;
  padding: 7px 8px;
  align-items: center;
  gap: 3px;
  border-radius: 8px;
  border: 1px solid var(--Global-Teal-800, #58c6bc);
  background: var(--Global-Teal-500, #bcece8);
  color: var(--character-primary-85, rgba(0, 0, 0, 0.85));
}

.saved-payment-bottom {
  display: flex;
  width: 100%;
  height: 76px;
  padding: 20px 32px 20px 583px;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 0px 0px 16px 16px;
  background: #fff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.15);
  z-index: 100000;
}

.catgery-save-all {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px 16px 32px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Configurations/Payment Gateways/savedPaymentModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,0CAA0C;EAC1C,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,uDAAuD;EACvD,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iDAAiD;EACjD,2CAA2C;EAC3C,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;AAC9B","sourcesContent":[".saved-payment-modal-root {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.saved-payment-modal-header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 32px;\n}\n\n.saved-payment-modal-title {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.saved-payment-modal-root .container-tabs {\n  width: 100%;\n  display: flex;\n  padding: 4px 20px 4px 20px;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 8px;\n  background: var(--Global-Neutral-Grey-200, #f8f8f8);\n}\n\n.active-tab {\n  display: flex;\n  height: 32px;\n  padding: 0px 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 6px;\n  background: var(--Global-Base-White, #fff);\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n  cursor: pointer;\n}\n\n.inActive-tab {\n  display: flex;\n  height: 32px;\n  padding: 0px 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.active-tab-font.MuiTypography-root {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.02px;\n}\n\n.inActive-tab-font.MuiTypography-root {\n  color: #4f4d55 !important;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.saved-payment-modal-content {\n  width: 100%;\n  height: 483px;\n}\n\n.saved-payment-warning-container {\n  display: flex;\n  padding: 6px 16px;\n  align-items: flex-start;\n  gap: 8px;\n  border-radius: 4px;\n  background: var(--Sunrise-Yellow-1, #feffe6);\n  box-shadow: 0px 0px 0px 1px #fff;\n  margin: 0px 32px 16px 32px;\n}\n\n.unselectall-warning-msg {\n  color: var(--character-primary-85, rgba(0, 0, 0, 0.85));\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* 166.667% */\n  letter-spacing: 0.16px;\n}\n\n.scroll-container {\n  height: 300px;\n  overflow-y: scroll;\n}\n\n.category-items-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 20px;\n  row-gap: 16px;\n  padding: 0px 32px 76px 32px;\n}\n\n.category-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--borderRadius, 4px);\n  border-radius: 6px;\n  border: 1px solid var(--Global-Neutral-Grey-600, #dcdcde);\n}\n\n.psp-img-title {\n  display: flex;\n  padding: 12px;\n  align-items: center;\n  width: 200px;\n  gap: 4px;\n}\n\n.scrollable-div::-webkit-scrollbar {\n  position: absolute;\n  left: 10px;\n}\n\n.category-font {\n  color: #0d1021;\n  text-align: center;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.processor-container {\n  display: flex;\n  padding: 7px 8px;\n  align-items: center;\n  gap: 3px;\n  border-radius: 8px;\n  border: 1px solid var(--Global-Teal-800, #58c6bc);\n  background: var(--Global-Teal-500, #bcece8);\n  color: var(--character-primary-85, rgba(0, 0, 0, 0.85));\n}\n\n.saved-payment-bottom {\n  display: flex;\n  width: 100%;\n  height: 76px;\n  padding: 20px 32px 20px 583px;\n  justify-content: flex-end;\n  align-items: flex-start;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 0px 0px 16px 16px;\n  background: #fff;\n  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.15);\n  z-index: 100000;\n}\n\n.catgery-save-all {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px 16px 32px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
